export enum ENGINE_TYPES {
	// ICE = 'ICE', //COMBUSTION
	// PEV = 'PEV', //FULL ELECTRIC
	OVC_HEV = 'OVC_HEV', //PLUGIN HYBRID
	NOVC_HEV = 'NOVC_HEV' //MILD HYBRID
	// NOVC_FCHV = 'NOVC_FCHV' //HIDROGEN
}

export enum EnergyManagementType {
	Pure = 'PURE',
	Weighted = 'WEIGHTED',
	Sustaining = 'SUSTAINING'
}
